import { lazy } from 'react';

export * from './create.controller.js';
export * from './display.controller.js';
export * from './quick-patrol.controller.js';
export const EccLogOnPage = lazy(() => import('./ecc-log-on.controller.js'));
export const RecordPatrolPage = lazy(() => import('./record/index.js'));

// intentionally left empty
